import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import bind from "memoize-bind";

import { SubBar, MainView, Form, FormMessage, Button, CompanyFullDecorator, HintView, st, Message } from "lib/index";
import { addWindowOnBeforeUnloadCallback } from "modules/utils/index";

export default function createCompanySettingsView({
  stateSelector,
  actions: { initializeView, updateModel, submit },
  title,
  FormContent,
  Hint,
}) {
  @connect(
    (state) => ({
      company: stateSelector(state).form.model,
      dirty: stateSelector(state).form.dirty,
      valid: stateSelector(state).form.valid,
      errors: stateSelector(state).form.errors,
      submitLoading: stateSelector(state).form.submitLoading,
      submitFailed: stateSelector(state).form.submitFailed,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          initializeView,
          updateModel,
          submit,
        },
        dispatch
      )
  )
  @withRouter
  class StripeSettingsView extends React.PureComponent {
    subscriptions = [];

    componentDidMount() {
      this.props.initializeView();

      addWindowOnBeforeUnloadCallback(this, () => {
        const { dirty } = this.props;
        if (dirty) {
          return I18n.t("papp.common.discard_changes_confirm_message");
        }
      });
    }

    componentWillUnmount() {
      this.subscriptions.forEach((s) => s.unsubscribe());
      this.subscriptions.length = 0;
    }

    handleSubmit(event) {
      event.preventDefault();
      this.props.submit();
    }

    handleCompanyPropChange(prop, value) {
      const { company, updateModel } = this.props;
      if (prop == "location") {
        updateModel(
          new CompanyFullDecorator({
            ...company,
            location_name: value.name,
            location_lat: value.lat,
            location_lng: value.lng,
          })
        );
        return;
      }
      updateModel(
        new CompanyFullDecorator({
          ...company,
          [prop]: value,
        })
      );
    }

    handleCompanyTranslationPropChange(translation, prop, value) {
      const { company, updateModel } = this.props;
      updateModel(
        new CompanyFullDecorator({
          ...company,
          translations: company.translations.map((t) =>
            t.uuid === translation.uuid
              ? {
                  ...translation,
                  [prop]: value,
                }
              : t
          ),
        })
      );
    }

    render() {
      const { company, valid, dirty, submitLoading, errors, updateModel } = this.props;
      const canEdit = !!company && st.authorize("update", company);
      return (
        company && (
          <MainView.Container>
            <SubBar hasSidebar>
              <div className="pull-left">
                <h1>{title}</h1>
              </div>
            </SubBar>

            <MainView.Content hasSubBar padded={false}>
              <HintView.Container>
                <HintView.Content>
                  <Form
                    className="text"
                    onSubmit={bind(this.handleSubmit, this)}
                    error={!valid}
                    loading={submitLoading}
                  >
                    {errors.base && <FormMessage error={errors.base} />}

                    {!canEdit && (
                      <Message warning visible>
                        {I18n.t("papp.settings.SettingsLayout.readonly_access_message")}
                      </Message>
                    )}

                    <FormContent
                      company={company}
                      errors={errors}
                      onChange={updateModel}
                      handleCompanyPropChange={bind(this.handleCompanyPropChange, this)}
                      handleCompanyTranslationPropChange={bind(this.handleCompanyTranslationPropChange, this)}
                      canEdit={canEdit}
                    />

                    {canEdit && <button type="submit" hidden />}
                  </Form>
                </HintView.Content>
              </HintView.Container>
            </MainView.Content>
          </MainView.Container>
        )
      );
    }
  }

  return StripeSettingsView;
}



// WEBPACK FOOTER //
// ./src/modules/settings/createStripeSettingsView.jsx